import React from "react";
import { Switch, Route } from "react-router-dom";
import Home from "../components/pages/Home";

export default (
    <Switch>
        <Route exact path="/" component={Home} />
        <Route exact path="/:articleData" component={Home} />
        <Route exact path="/:articleData/:backToId" component={Home} />
        <Route
            exact
            path="/:articleData/:backToId/:downloadParam"
            component={Home}
        />
    </Switch>
);
